import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import React from 'react';
import styles from './index.module.scss';
import Layout from '../../components/Layout';
import { DateTime } from 'luxon';
import { css } from '../../lib/utils/css';
var Interval = function(param) {
    var className = param.className, start = param.start, end = param.end;
    var FORMAT_LONG = 'ccc dd LLL HH:mm';
    var FORMAT_SHORT = 'HH:mm';
    var startDate = DateTime.fromJSDate(start);
    var endDate = DateTime.fromJSDate(end);
    var startFormatted = startDate.toFormat(FORMAT_LONG);
    var endFormatted = endDate.toFormat(startDate.day === endDate.day ? FORMAT_SHORT : FORMAT_LONG);
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            startFormatted,
            " - ",
            endFormatted
        ]
    });
};
var index = function(param) {
    var preamble = param.preamble, events = param.events;
    return /*#__PURE__*/ _jsxs(Layout, {
        title: 'Events',
        children: [
            /*#__PURE__*/ _jsx("div", {
                dangerouslySetInnerHTML: {
                    __html: preamble
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.eventsTable,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.header,
                        children: "Time"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.header,
                        children: "Name"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.header,
                        children: "Location"
                    }),
                    events.map(function(event, i) {
                        var className = css(styles.cell, i % 2 === 1 && styles.stripe);
                        return /*#__PURE__*/ _jsxs(React.Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Interval, {
                                    className: className,
                                    start: event.startTime,
                                    end: event.endTime
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: className,
                                    children: event.name
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: className,
                                    children: event.location
                                })
                            ]
                        }, event.id);
                    }),
                    !events.length && /*#__PURE__*/ _jsx("div", {
                        children: "There are currently no upcoming events."
                    })
                ]
            })
        ]
    });
};
export var __N_SSG = true;
export default _withSuperJSONPage(index);
